<template>
    <div class="ps-hero-stage" aria-hidden="true">
        <!-- Ambient rings -->
        <div class="ps-hero-stage__ring ps-hero-stage__ring--outer" />
        <div class="ps-hero-stage__ring ps-hero-stage__ring--inner" />

        <!-- Floating tool chips -->
        <div class="ps-hero-chip ps-hero-chip--print ps-hero-float-slow">
            <icon name="print" class="ps-hero-icon w-3.5 h-3.5" />
            <span>Print Studio</span>
        </div>
        <div class="ps-hero-chip ps-hero-chip--bio ps-hero-float-delayed">
            <icon name="website" class="ps-hero-icon w-3.5 h-3.5" />
            <span>Link-in-Bio</span>
        </div>
        <div class="ps-hero-chip ps-hero-chip--lead ps-hero-float-slow">
            <icon name="contact" class="ps-hero-icon w-3.5 h-3.5" />
            <span>Lead Forms</span>
        </div>

        <div class="ps-hero-stage__content">
            <!-- Print business card -->
            <div class="ps-hero-print ps-hero-float-card">
                <div class="ps-hero-print__shine" />
                <div
                    class="ps-hero-print__card"
                    :style="{ backgroundImage: `url('${cardBg}')` }"
                >
                    <div class="ps-hero-print__overlay" />
                    <div class="ps-hero-print__body">
                        <div class="ps-hero-print__brand">
                            <img :src="cardLogo" alt="" class="ps-hero-print__logo" />
                            <div>
                                <p class="ps-hero-print__company">ProfileSuite</p>
                                <p class="ps-hero-print__tagline">Design · Print · Share</p>
                            </div>
                        </div>
                        <div class="ps-hero-print__contact">
                            <p class="ps-hero-print__name">Sarah Chen</p>
                            <p class="ps-hero-print__role">Creative Director</p>
                            <p class="ps-hero-print__detail">sarah@profilesuite.io</p>
                        </div>
                        <img :src="qrImage" alt="" class="ps-hero-print__qr" />
                    </div>
                </div>
                <span class="ps-hero-print__label">Print-ready</span>
            </div>

            <!-- Phone: digital card -->
            <div class="ps-hero-phone ps-hero-float-phone">
                <div class="ps-hero-phone__frame">
                    <div class="ps-hero-phone__notch" />
                    <div class="ps-hero-phone__screen">
                        <div class="ps-hero-phone__header">
                            <div class="ps-hero-phone__avatar">SC</div>
                            <div>
                                <p class="ps-hero-phone__name">Sarah Chen</p>
                                <p class="ps-hero-phone__role">Creative Director</p>
                            </div>
                        </div>
                        <div class="ps-hero-phone__actions">
                            <span class="ps-hero-phone__pill">Save contact</span>
                            <span class="ps-hero-phone__pill ps-hero-phone__pill--ghost">Share card</span>
                        </div>
                        <div class="ps-hero-phone__links">
                            <div v-for="link in phoneLinks" :key="link" class="ps-hero-phone__link">
                                <span class="ps-hero-phone__link-dot" />
                                {{ link }}
                            </div>
                        </div>
                        <div class="ps-hero-phone__qr-row">
                            <span>Tap or scan</span>
                            <img :src="qrImage" alt="" class="ps-hero-phone__qr" />
                        </div>
                    </div>
                </div>
                <span class="ps-hero-phone__label">Digital card</span>
            </div>
        </div>

        <!-- Glass platform -->
        <div class="ps-hero-stage__platform">
            <div class="ps-hero-stage__platform-glow" />
        </div>

        <!-- Live indicator -->
        <div class="ps-hero-live">
            <span class="ps-hero-live__dot" />
            <span>12+ tools · one workspace</span>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
    name: 'HomeHeroVisual',
    components: { Icon },
    data() {
        return {
            cardBg: '/images/card/default-card-background.jpg',
            cardLogo: '/images/card/default-card-logo.png',
            qrImage: '/images/card/qr.svg',
            phoneLinks: ['Website', 'Portfolio', 'Book a call'],
        }
    },
}
</script>
